import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogActions } from '@mui/material';

import { Button } from '@components/base';

import { ConfirmAction } from './types';

type ConfirmActionsProps = {
  action: ConfirmAction;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const ConfirmActions: FC<ConfirmActionsProps> = ({ action, loading, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <DialogActions>
      <Button
        disabled={loading}
        onClick={e => {
          e.stopPropagation();
          onCancel();
        }}
      >
        {action === 'ok' ? t('cancel') : t('no')}
      </Button>

      <Button
        loading={loading}
        onClick={e => {
          e.stopPropagation();
          onConfirm();
        }}
        variant='contained'
      >
        {t(action)}
      </Button>
    </DialogActions>
  );
};

export default ConfirmActions;
